import React from "react";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import MailIcon from "@material-ui/icons/Mail";
import {carBrands} from "../../../AppConstants";


export default function (props){
	return(<div style={{marginBottom:'55px'}}>
		<div style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar-Secondary':'LandRover-Secondary'}`}}  className={'flex'}><LocationOnIcon style={{marginRight:'10px'}}/><a rel={'noopener noreferrer'} target={'_blank'} href={props.location.locationURL}>{props.location.locationName}</a></div>
		<div style={{marginTop:'10px'}} className={'flex'}><PhoneIcon style={{marginRight:'10px'}}/> <a href={`tel:${props.tele.replace(/\\s/g, '')}`}>{props.tele}</a></div>
		<div style={{marginTop:'10px'}} className={'flex'}><MailIcon style={{marginRight:'10px'}}/><a href={`mailto:${props.email}`}>{props.email}</a></div>
	</div>)
}
